import React from "react";
import { shallowEqual } from "react-redux";
import { useTradeInAemSelector } from "../../../redux/store";
import * as Styles from "./styles/TradeInAem";
import { stepHeaderLabelSelector } from "../../../utils/selectors";

const TradeInAemStepHeader = (): JSX.Element => {
    const { titleLabel, descriptionLabel } = useTradeInAemSelector(stepHeaderLabelSelector, shallowEqual);

    return (
        <Styles.Intro>
            <Styles.Container>
                <h3>{titleLabel}</h3>
                <div>{descriptionLabel}</div>
            </Styles.Container>
        </Styles.Intro>
    );
};
export default TradeInAemStepHeader;
